const router = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/index/Login.vue'),
    meta: {
      title: '首页',
      checkToken: false
    }
  }
];
export default router;
